






































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import CouponApi from "@/api/marketing/coupon/index";
@Component
export default class PrizeSelect extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  selectedItems!: string[];

  @Prop({
    type: Boolean,
    default: true
  })
  IsMultiple!: boolean;

  modal1: boolean = false;
  total: number = 0;
  pageIndex: number = 1

  rewardPointValue: number = 0;
  name: string = "谢谢参与";
  currentTab: string = "coupon";

  data = [];
  get showFooter() {
    return this.currentTab === "coupon";
  }
  get columns() {
    var data: any[] = [
      {
        title: "优惠券名称",
        width: 350,
        key: "name"
      },
      {
        title: "有效期",
        key: "validDate"
      },
      {
        title: "数量",
        key: "circulation"
      }
    ];
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: "selection",
        width: 60,
        align: "center"
      });
    }
    return data;
  }
  async mounted() {}
  @Watch("modal1")
  async modalShowChange(show) {
    if (show) await this.loadGoodsList();
  }

  async loadGoodsList() {
    CouponApi.getList(10, this.pageIndex).then(res => {
      this.total = res.data.totalCount;
      let result = [];
      res.data.items.forEach(element => {
        element["_disabled"] =
          this.selectedItems.findIndex(x => x == element.id) > -1;
        result.push(element);
      });
      this.data = result;
    });
  }

  onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    this.loadGoodsList()
  }


  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit("on-change", {
        value: currentRow.id,
        name: currentRow.name,
        couponType: currentRow.couponType,
        discountValue: currentRow.discountValue,
        type: 0
      });
      this.modal1 = false;
    }
  }
  tabChange(name) {
    this.currentTab = name;
  }

  ok() {
    if (this.currentTab === "coupon") {
      // if ((this.$refs.selection as any).getSelection().length <= 0) {
      //   this.$Message.warning("请选择优惠券");
      //   return false;
      // }
      // this.$emit("on-change", (this.$refs.selection as any).getSelection());
    } else if (this.currentTab === "rewardPoint") {
      this.$emit("on-change", {
        name: `积分${this.rewardPointValue}`,
        value: this.rewardPointValue,
        type: 1
      });
    } else {
      this.$emit("on-change", { name: this.name, value: 0, type: 2 });
    }
  }
}
